// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./components/style/index.less
 ** module id = 12
 ** module chunks = 0
 **/